export enum MonacoEditorTheme {
  Light = 'vs-light',
  Dark = 'vs-dark'
}
